/**
* Jump Links JS
* -----------------------------------------------------------------------------
*
* All the JS for the Jump Links component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin.js';
gsap.registerPlugin( ScrollTrigger );
gsap.registerPlugin( ScrollTrigger, ScrollToPlugin );
( function( app ) {
  const COMPONENT = {

    className: 'jump-links',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const updateTopOffset = () => {
        let topOffset = $( 'header' ).height() || 0;
        if ( $( 'body.logged-in' ).length > 0 ) {
          topOffset += 32;
        }
        return topOffset;
      };

      const mobileSize = window.matchMedia( '(max-width: 1024px)' );
      $( '.jump-links-toggle-btn' ).on( 'toggleBefore', function( event ) {
        if ( mobileSize.matches ) {
          $( event.target ).next().slideToggle( );
        }
      } );

      /* ADA */

      function handleLargeChange( event ) {
        if ( event.matches && !$( '.jump-links__toggle-btn' ).hasClass( 'is-open' ) ) {
          $( '.jump-links__dropdown' ).attr( 'aria-hidden', true );
        } else if ( !event.matches && !$( '.jump-links__toggle-btn' ).hasClass( 'is-open' ) ) {
          $( '.jump-links__dropdown' ).attr( 'aria-hidden', false );
          $( '.jump-links__dropdown' ).get( 0 ).style.removeProperty( 'display' );
        } else if ( !event.matches && $( '.jump-links__toggle-btn' ).hasClass( 'is-open' ) ) {
          $( '.jump-links__toggle-btn' ).trigger( 'click' );
          $( '.jump-links__dropdown' ).attr( 'aria-hidden', false );
          $( '.jump-links__dropdown' ).get( 0 ).style.removeProperty( 'display' );
        }
      }

      /* ADA close the dropdown if you have tabbed outside it */
      $( '.jump-links' ).on( 'focusout', function( event ) {
        if ( event.relatedTarget !== null && window.matchMedia( '(max-width: 1024px)' ).matches ) {
          const reltarget = $( event.relatedTarget );
          const currenttarget = $( event.currentTarget );

          if ( ( reltarget.closest( '.jump-links' ).length === 0 ) && window.easyToggleState.isActive( $( '.jump-links__toggle-btn' ).get( 0 ) ) ) {
            $( '.jump-links__toggle-btn' ).trigger( 'click' );
          }
        }
      } );

      $( '.jump-links__link' ).on( 'click', function( event ) {
        event.preventDefault();

        const targetId = $( this ).attr( 'href' );
        const targetElement = document.querySelector( targetId );

        if ( targetElement ) {
          const offset = targetElement.getBoundingClientRect().top + window.scrollY;
          const topOffset = updateTopOffset();
          const scrollToPosition = offset - topOffset;

          gsap.to( window, {
            duration: 0.6,
            scrollTo: scrollToPosition,
            ease: 'power2.out',
          } );
        }

        $( '.jump-links__toggle-btn' ).trigger( 'click' );
      } );


      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      mobileSize.addEventListener( 'change', handleLargeChange );
      handleLargeChange( window.matchMedia( '(max-width: 1024px)' ) );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'jump-links', COMPONENT );
} )( app );
